var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveUpMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Send_up_icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 3",
    d: "M13.124 4.125v15.749a1.125 1.125 0 11-2.249 0V4.125a1.125 1.125 0 112.249 0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 5",
    d: "M16.938 7.955a1.125 1.125 0 01-1.922.794L11.999 5.72 8.983 8.749A1.125 1.125 0 117.39 7.162l3.812-3.83a1.125 1.125 0 011.594 0l3.814 3.83a1.121 1.121 0 01.328.793z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15111",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgMoveUpMobile;